<template>
	<div class="appContainer">
		<Header v-if="$mq=='lg'"/>


		<div class="errorContent center">
			<router-view/>
		</div>

		<Footer/>

	</div>
</template>

<script>
    import Header from './Header';
    import Footer from './Footer';

    export default {
        components: {
            Header, Footer
        },
    }
</script>

<style scoped>
	.errorContent {
		flex: 1;
		margin: 100px 0;
	}
</style>
